import { faLockKeyhole } from '@fortawesome/pro-regular-svg-icons'

import { EmptyState, FormattedMessage } from '@b-stock/fe-core/bstock-react'

const ns = 'Listing.errors.privateListing'

export const PrivateListingErrorBanner = () => {
  return (
    <EmptyState
      icon={faLockKeyhole}
      title={<FormattedMessage id={`${ns}.title`} />}
      description={<FormattedMessage id={`${ns}.description`} />}
      size={4}
    />
  )
}
